import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';

@UntilDestroy()
@Component({
    selector: 'app-new-agreement-notes-activities',
    templateUrl: './new-agreement-notes-activities.component.html',
    styleUrl: './new-agreement-notes-activities.component.scss'
})
export class NewAgreementNotesAndActivitiesComponent {
    @Input() public agreementForm: FormGroup<AgreementForm>;
    @Input() public showPotentialValidationMessages: boolean;
    @Output() public fileDialogStateChange = new EventEmitter<boolean>();

    public get detailsForm() {
        return this.agreementForm.controls.details;
    }

    public get noteReminderForm() {
        return this.agreementForm.controls.notesReminders;
    }

    public get f() {
        return this.agreementForm.controls;
    }

    public onFileDialogStateChange(isOpen: boolean) {
        this.fileDialogStateChange.emit(isOpen);
    }
}
